import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const SidebarContainer = styled.aside`
  width: 250px;
  background-color: rgba(247, 247, 243, 0.86);
  border-right: 1px solid var(--color-border);
  height: calc(100vh - 80px);
  position: fixed;
  left: 0;
  top: 80px;
  padding: 36px 20px;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    transform: translateX(-100%);
    transition: transform var(--transition-speed) ease;
    z-index: 50;
    
    &.open {
      transform: translateX(0);
    }
  }
`;

const MenuHeader = styled.h2`
  font-family: var(--font-sans);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  margin-bottom: 22px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-light);
  letter-spacing: 0.2em;
  text-transform: uppercase;
`;

const MenuItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  margin-bottom: 6px;
  border-radius: var(--border-radius-md);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  transition: all var(--transition-speed) ease;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background-color: var(--color-bronze);
    transform: scaleY(0);
    transition: transform var(--transition-speed) ease;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.82);
    color: var(--color-primary);
    
    &:before {
      transform: scaleY(1);
    }
  }
  
  &:focus {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
  
  &.active {
    background-color: var(--color-surface);
    color: var(--color-accent);
    font-weight: var(--font-weight-semibold);
    box-shadow: inset 0 0 0 1px var(--color-border);
    
    &:before {
      transform: scaleY(1);
      background-color: var(--color-bronze);
    }
    
    &:hover {
      background-color: var(--color-surface);
      color: var(--color-accent);
    }
  }
`;

const Sidebar = () => {
  return (
    <SidebarContainer>
      <MenuHeader>Artist Management</MenuHeader>
      <MenuItem to="/artists/existing" end>
        Existing Artists
      </MenuItem>
      <MenuItem to="/artists/requests">
        Pending Requests
      </MenuItem>
      <MenuItem to="/artists/invite">
        Invite Artist
      </MenuItem>
      <MenuItem to="/artists/sent-invites">
        Sent Invites
      </MenuItem>
      <MenuItem to="/artists/test-artists">
        Test Artists
      </MenuItem>
      <MenuHeader style={{ marginTop: 32 }}>Operations</MenuHeader>
      <MenuItem to="/disputes">
        Disputes
      </MenuItem>
      <MenuItem to="/shipping">Shipments</MenuItem>
      <MenuHeader style={{ marginTop: 32 }}>Settings</MenuHeader>
      <MenuItem to="/settings/payments">
        Payment Settings
      </MenuItem>
    </SidebarContainer>
  );
};

export default Sidebar;
